








import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class TimerComponent extends Vue {
  @Prop() initTimeBySec: number
  timeString: string = ''
  currentTime: number = 0
  timer: any = 0
  
  created() {
    this.timeString = this.setLimitTimeString(this.initTimeBySec)
    this.currentTime = this.initTimeBySec
    this.startTimer()
  }
  
  beforeUnmount() {
    clearInterval(this.timer)
  }

  setTimeString() {
    if(this.currentTime < 0) {
      clearInterval(this.timer)
      this.$emit('time_up')
      return
    }
    this.timeString = this.setLimitTimeString(this.currentTime)
  }

  startTimer() {
    if(!this.timer) {
      this.timer = setInterval(() => {
        this.currentTime = this.currentTime - 1
        this.setTimeString()
      }, 1000)
    }
  }

  setLimitTimeString(limitTimeSec: number) {
    const min = Math.floor(limitTimeSec/ 60)
    const sec = limitTimeSec % 60
    return `${min}:${sec > 9 ? sec : `0${sec}`}`
  }
}
